import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";

import { BarChart } from "components/BarChart";
import { Cut } from "components/Cut";
import { getWarehouses } from "services/apiWarehouse";

import { ChangeWarehouse } from "../ChangeWarehouse";
import "./writeOffProductTable.scss";
import { existRender } from "utils/existRender";
import { CutLink } from "components/CutLink";
import { useNomenclatureModal } from "contexts/NomenclatureModalContext";

export const WriteOffProductTable = ({
  products,
  carriedOut,
  setProducts,
  setLoading,
}) => {
  const [warehouses, setWarehouses] = useState([]);
  const { openNomenclatureModal } = useNomenclatureModal();

  const getAndSetWarehouses = () => {
    getWarehouses()
      .then(setWarehouses)
      .catch((e) => console.error(e));
  };

  useEffect(() => {
    getAndSetWarehouses();
    // eslint-disable-next-line
  }, []);

  const tableProductsColumns = [
    {
      dataField: "index",
      text: "№",
      headerStyle: (colum, colIndex) => {
        return { width: "2%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "brand",
      text: "Бренд",
      formatter: (cell, row) => <CutLink
        onClick={() => openNomenclatureModal(row.nomenclature?.id)}
        nomenclature={row.nomenclature}
      >
        {row.nomenclature?.brand}
      </CutLink>,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "article",
      text: "Артикул",
      formatter: (cell, row) => <CutLink
        onClick={() => openNomenclatureModal(row.nomenclature?.id)}
        nomenclature={row.nomenclature}
      >
        {row.nomenclature?.article}
      </CutLink>,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "name",
      text: "Наименование",
      formatter: (cell, row) => <CutLink
        onClick={() => openNomenclatureModal(row.nomenclature?.id)}
        nomenclature={row.nomenclature}
      >
        {row.nomenclature?.name}
      </CutLink>,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "inStock",
      text: "Ост.",
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      formatter: (cell, row) => (
        <div className="warehouse-container">

          {(cell || row.inStockAll) && (
            <BarChart
              color={cell > 0 ? "green" : "red"}
              count={existRender(row)}
            />
          )}
        </div>
      ),
      headerClasses: () => "right",
      classes: (cell) => "right",
      footer: () => null,
      editable: false,
    },
    {
      dataField: "count",
      text: "Кол-во",
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      headerClasses: () => "right",
      footerClasses: () => "right",
      classes: () => "editable right",
      formatter: (cell, row) => row.count,
    },
    {
      dataField: "warehouse",
      text: "Склад",
      headerStyle: (colum, colIndex) => {
        return { width: "17%" };
      },
      formatter: (cell, row) => {
        if (carriedOut) {
          return cell?.name;
        }
        return (
          <ChangeWarehouse
            row={row}
            warehouses={warehouses}
            setProducts={setProducts}
            setLoading={setLoading}
          />
        );
      },
      footer: () => null,
      editable: false,
    },
    {
      dataField: "",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "40%" };
      },
      editable: false,
      footer: (columnData) => <></>,
    },
  ];

  const rowClasses = (row, rowIndex) => {
    const foundCarriedOut = products.find((item) => item.carriedOut);

    if (foundCarriedOut && !row.carriedOut) {
      return "error";
    }
  };

  return (
    <>
      <BootstrapTable
        wrapperClasses="write-off-product"
        keyField="id"
        data={products}
        columns={tableProductsColumns}
        bootstrap4
        bordered={false}
        rowClasses={rowClasses}
      />
    </>
  );
};
